import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';
import { customerId } from 'common/helpers/tokenHelper';

export const setupIntent = () =>
  axios.post(
    `${getV2RootUrl()}/payment/${customerId()}/stripe/setup-intent`,
    {},
    axiosHeaderV2()
  );

export const createCustomerAndSetupIntent = (cartId, customerPayload) =>
  axios.post(
    `${getV2RootUrl()}/cart/${cartId}/customer-and-setup-intent`,
    customerPayload,
    axiosHeaderV2()
  );
